import React, { useEffect, useState } from "react";
import { Button, Input, Pagination, Table, Tooltip, Whisper } from "rsuite";
import { handleDownloadAsExcel } from "../../../Helpers/Utils";
import { WeightageVM } from "../../../Models/ViewModels";
import { GetWeightageDetails } from "../../../Services/WeightageDB";
import { BootstrapIcon } from "../../../SharedComponents/BootstrapIcon";
import { CustomTableCell } from "../../../SharedComponents/CustomTableCell";
import { CustomTableHeaderCell } from "../../../SharedComponents/CustomTableHeaderCell";
import { PageHeader } from "../../../SharedComponents/PageHeader";
import { WightageModal } from "./WeightageModalDisp";
import * as userManager from "../../../Services/UserSessionManager";
import { Dropdown, DropdownButton, Form, InputGroup } from "react-bootstrap";

const { Column, HeaderCell, Cell } = Table;
export const WeightageList = () => {
  const [checkRole, setCheckRole] = useState(userManager.GetUserRole());

  const [cachedWeightageList, setCachedWeightageList] = useState(
    new Array<WeightageVM>()
  );
  const [sortColumn, setSortColumn] = useState();
  const [isLoading, setLoading] = useState(true);
  const [sortType, setSortType] = useState();
  const [page, setPage] = React.useState(1);
  const [limit, setLimit] = React.useState(15);
  const [filteredWeightageList, setFilteredWeightageList] = useState(
    new Array<WeightageVM>()
  );

  const [searching, setSearching] = useState(false);
  const [searchby, setSearchBy] = useState("Dropdown");
  const [searchby2, setSearchBy2] = useState("Dropdown");
  useEffect(() => {
    GetWeightageList();
  }, []);

  const GetWeightageList = () => {
    GetWeightageDetails().then((res: any) => {
      setCachedWeightageList(res.data);
      setFilteredWeightageList(res.data);
      setLoading(false);
    });
  };

  const filterData = () => {
    setPage(1);
    let search1value = (document.getElementById("Search1") as HTMLInputElement)
      .value;
    let search2value = (document.getElementById("Search2") as HTMLInputElement)
      .value;

    setFilteredWeightageList(
      cachedWeightageList.filter(
        (e) =>
          includesSearchValue(e, searchby, search1value) &&
          includesSearchValue(e, searchby2, search2value)
      )
    );
  };

  const includesSearchValue = (
    e: WeightageVM,
    searchBy: string,
    searchText: string
  ) => {
    switch (searchBy) {
      case "Account":
        return e.AccountName.toLowerCase().includes(searchText.toLowerCase());

      case "Process":
        return e.ProcessName.toLowerCase().includes(searchText.toLowerCase());

      case "SubState":
        return e.SubStateName.toLowerCase().includes(searchText.toLowerCase());

      default:
        return JSON.stringify(e)
          .toLowerCase()
          .includes(searchText.toLowerCase());
    }
  };

  const handleChangeLimit = (dataKey: any) => {
    setPage(1);
    setLimit(dataKey);
  };

  const tableDataFeed = filteredWeightageList.filter((v, i) => {
    const start = limit * (page - 1);
    const end = start + limit;
    return i >= start && i < end;
  });

  const handleSortColumn = (sortColumn: any, sortType: any) => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setSortColumn(sortColumn);
      setSortType(sortType);
    }, 500);
    if (sortColumn && sortType) {
      return filteredWeightageList.sort((a: any, b: any) => {
        let x = a[sortColumn];
        let y = b[sortColumn];
        if (typeof x === "string" || "") {
          x = x.charCodeAt();
        }
        if (typeof y === "string" || "") {
          y = y.charCodeAt();
        }
        if (sortType === "asc") {
          return x - y;
        } else {
          return y - x;
        }
      });
    }
  };

  const WeightageInfo: WeightageVM = new WeightageVM();

  const addWeightage = (prrDetail: WeightageVM) => {
    GetWeightageList();
  };
  const editWeightage = (prrDetail: WeightageVM) => {
    GetWeightageList();
  };
  const deleteWeightage = (prrDetail: WeightageVM) => {
    GetWeightageList();
  };

  const SearchBy = (value: any) => {
    setSearchBy(value);
  };
  const SearchBy2 = (value: any) => {
    setSearchBy2(value);
  };
  return (
    <>
      <div className="row">
        <div className="col-md-4">
          <PageHeader title="Productivity Target Master" backPage="">
            <></>
          </PageHeader>
        </div>
        <div className="col-md-3">
          <InputGroup className="mb-3">
            <DropdownButton
              variant="outline-secondary"
              title={searchby}
              id="input-group-dropdown-1"
            >
              <Dropdown.Item href="#" onClick={() => SearchBy("Account")}>
                Account
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy("Process")}>
                Process
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy("SubState")}>
                SubState
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy("Dropdown")}>
                Default
              </Dropdown.Item>
            </DropdownButton>
            <Form.Control
              aria-label="Text input with dropdown button"
              id="Search1"
              onChange={(event) => filterData()}
              placeholder="Search..."
            />
          </InputGroup>
        </div>
        <div className="col-md-3">
          <InputGroup className="mb-3">
            <DropdownButton
              variant="outline-secondary"
              title={searchby2}
              id="input-group-dropdown-1"
            >
              <Dropdown.Item href="#" onClick={() => SearchBy2("Account")}>
                Account
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy2("Process")}>
                Process
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy2("SubState")}>
                SubState
              </Dropdown.Item>
              <Dropdown.Item href="#" onClick={() => SearchBy2("Dropdown")}>
                Default
              </Dropdown.Item>
            </DropdownButton>
            <Form.Control
              aria-label="Text input with dropdown button"
              id="Search2"
              onChange={(event) => filterData()}
              placeholder="Search..."
            />
          </InputGroup>
        </div>
        <div className="col-md-1">
          {searching == true ? (
            <button
              id="color"
              onClick={() => handleDownloadAsExcel(tableDataFeed)}
            >
              <BootstrapIcon
                bootStrapIconName={"file-earmark-arrow-down-fill"}
                size={35}
                cssClasses={"pe-2"}
              />{" "}
            </button>
          ) : (
            <button
              id="color"
              onClick={() => handleDownloadAsExcel(cachedWeightageList)}
            >
              <BootstrapIcon
                bootStrapIconName={"file-earmark-arrow-down-fill"}
                size={35}
                cssClasses={"pe-2"}
              />{" "}
            </button>
          )}
        </div>

        <div className="col-md-1">
          {checkRole == "H" || checkRole == "A" ? (
            <WightageModal
              action="add"
              data={WeightageInfo}
              cachedData={cachedWeightageList}
              onAction={addWeightage}
            />
          ) : (
            <></>
          )}
          <br />
        </div>

        <hr />
      </div>

      <div className="show-container " bg-color="pink">
        <Table
          id="table"
          data={tableDataFeed}
          height={450}
          loading={isLoading}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={handleSortColumn}
          bordered={true}
          cellBordered={true}
          className="border border-dark mt-2"
          autoHeight={true}
          rowHeight={30}
          headerHeight={30}
        >
          <Column flexGrow={90} align="center" sortable>
            <CustomTableHeaderCell placement={"ID"}>ID</CustomTableHeaderCell>
            <CustomTableCell dataKey="WeightageID" />
          </Column>

          <Column flexGrow={400} align="center" sortable>
            <CustomTableHeaderCell placement={"Account Name"}>
              Account Name
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="AccountName" />
          </Column>

          <Column flexGrow={150} align="center">
            <CustomTableHeaderCell placement={"Process Name"}>
              Process Name
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="ProcessName" />
          </Column>

          <Column flexGrow={350} align="center">
            <CustomTableHeaderCell placement={"SubState Name"}>
              SubState Name
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="SubStateName" />
          </Column>
          <Column flexGrow={80} align="center">
            <CustomTableHeaderCell placement={"Target 1"}>
              Target 1
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="Target1" />
          </Column>
          <Column flexGrow={80} align="center">
            <CustomTableHeaderCell placement={"Target 2"}>
              Target 2
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="Target2" />
          </Column>
          <Column flexGrow={80} align="center">
            <CustomTableHeaderCell placement={"Target 3"}>
              Target 3
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="Target3" />
          </Column>
          <Column flexGrow={80} align="center" sortable>
            <CustomTableHeaderCell placement={"Status"}>
              Status
            </CustomTableHeaderCell>
            <CustomTableCell dataKey="status" />
          </Column>

          {checkRole == "H" || checkRole == "A" ? (
            <Column flexGrow={100} align="center">
              <CustomTableHeaderCell> </CustomTableHeaderCell>
              <CustomTableCell>
                {(rowData: WeightageVM) => {
                  if (rowData.status === "Active") {
                    return (
                      <div className="d-flex justify-content-center align-items-center flex-row gap-3">
                        <WightageModal
                          action="delete"
                          data={rowData}
                          cachedData={cachedWeightageList}
                          onAction={deleteWeightage}
                        />
                        <WightageModal
                          action="edit"
                          data={rowData}
                          cachedData={cachedWeightageList}
                          onAction={editWeightage}
                        />
                      </div>
                    );
                  } else {
                    return (
                      <BootstrapIcon
                        bootStrapIconName="x-circle-fill text-danger"
                        size={15}
                        cssClasses="me-1"
                      ></BootstrapIcon>
                    );
                  }
                }}
              </CustomTableCell>
            </Column>
          ) : (
            <></>
          )}
        </Table>

        {filteredWeightageList && (
          <div style={{ padding: 20 }}>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              size="md"
              layout={["total", "-", "limit", "|", "pager", "skip"]}
              total={filteredWeightageList.length}
              limitOptions={[10, 15, 20, 25, 30]}
              limit={limit}
              activePage={page}
              onChangePage={setPage}
              onChangeLimit={handleChangeLimit}
            />
          </div>
        )}
      </div>
    </>
  );
};
